import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from './user-data';
import { CommonData } from '../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";

@Injectable()
export class LogperiodicjobsData {
  public data: any;
  public status: 'ok';

  constructor(public http: Http, public common: CommonData, public userData: UserData) {

  }
  clear(){
    if(this.data!=null){
      this.data.length = 0;
    }
  }
  load() {
    return new Promise(resolve => {
      if(this.userData.loggedin){
        var data = JSON.stringify({
          token: this.userData.jwt
      });
      if((this.userData.usergroup_id == 1) ){
        this.http.post(this.common.baseurl+'logperiodicjobs/index',data).subscribe(res => {
          this.data = res.json().data.data;
          this.status = res.json().data.status;
          //console.log("logperiodicjobs:");
          //console.log(this.data);
          resolve(this.data.data);
        }, error => {
          console.log('HTTP Error, no answer logperiodicjobs-data.ts');
          console.log(error);
      });        

      }
      else{
        //OODresolve([]);
      }


      }
    });
  }


}



// WEBPACK FOOTER //
// ./src/providers/logperiodicjobs-data.ts